// PAD-32395: the ADM/EDDM address box rule for the design step, kept pure so the gallery, the step
// completion and the submit gate apply one rule.

export interface AddressBoxCarrier {
  readonly addressBox?: boolean | null;
}

export interface DesignPickPlan {
  readonly select: boolean;
  readonly activate: boolean;
  readonly askForAddressBox: boolean;
}

export interface HeldDesignState<T> {
  readonly held: T | null;
  readonly selected: T | null;
}

// Only a confirmed address box passes; a missing flag is treated as no box.
export const lacksAddressBox = (required: boolean, design: AddressBoxCarrier | null | undefined): boolean =>
  required && !!design && design.addressBox !== true;

// A pick without an address box waits for the user's choice and is never activated on the campaign.
export const planDesignPick = (required: boolean, design: AddressBoxCarrier): DesignPickPlan =>
  lacksAddressBox(required, design)
    ? { select: false, activate: false, askForAddressBox: true }
    : { select: true, activate: true, askForAddressBox: false };

// "Add address box" works on the held pick, or on the selected design when Continue raised the popup.
export const addressBoxTarget = <T>({ held, selected }: HeldDesignState<T>): T | null => held ?? selected;

// An active design known only by id (not hydrated yet) counts, so a reload is not bounced; the submit gate re-checks.
export const designStepHasAddressBox = ({
  required,
  hasDesign,
  selectedDesign,
}: {
  readonly required: boolean;
  readonly hasDesign: boolean;
  readonly selectedDesign: AddressBoxCarrier | null;
}): boolean => hasDesign && !lacksAddressBox(required, selectedDesign);
